import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { BaseView, FreedataCall, FreeDataVO, LanguageCmd, AiCmd, DOCUMENT_EXT } from '@wizeoo/akm-common-lib';
import { WizDatasource, WizGroupCommand, WizTextarea } from '@wizeoo/akm-component-lib';
import { Model } from 'src/app/model/model';

import { IaResponseCmd } from 'src/app/cmd/ia/iaresponse.cmd';
import { AiResponse } from '@wizeoo/akm-message-lib';

@Component({
  selector: 'test-view',
  templateUrl: './test.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class TestView extends BaseView {

  @ViewChild('aiQuestion', { read: WizTextarea }) aiQuestion: WizTextarea; // question IA
  @ViewChild('aiImage', { read: WizTextarea }) aiImage: WizTextarea; // demande de dessin IA

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef ) {
    super(elementRef);
  }

  public questionResponse: string = null; // retour sur question simple
  public cvResponse: string = null; // retour sur analyse CV
  public cvVector: string = null; // retour sur analyse CV, vecteur
  public imageResponse: string = null; // retour sur image

 
  /**
   * Pretraitement: elaboration de la WizCommand d'initialisation
   * @return WizCommand La commande de recherche des free data
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const calls = [];
    // Chargement des langues si vide
    if (!Model.getInstance().languageMap) {
      calls.push(new LanguageCmd(Model.getInstance()).find());
    }
    calls.push(new FreedataCall(Model.getInstance()));
    calls.push(new IaResponseCmd(Model.getInstance()).find());
    // calls.push(new AiCmd(Model.getInstance()).question("luc est-il capable d'appeler openAI depuis JAVA ?", 150));

    return new WizGroupCommand().configure(calls);
  }

  /** Data source du multidisplay (liste des FDs) */
  public freedataDS: WizDatasource<FreeDataVO> = new WizDatasource<FreeDataVO>()
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  public freedataColumns:any[] = [
        { headerName: '$.common.code.$', width: 120, sortable: true, field: 'shortCode', tooltipField: 'shortCode' },
        { headerName: '$.common.label.$', minWidth: 180, flex: 1, sortable: true, field: 'trsLabel' },
        { headerName: '$.common.item.$', width: 80, sortable: true, field: 'childrenCount' }
      ];

  /** Data source du multidisplay (liste des FDs) */
  public responseDS: WizDatasource<AiResponse> = new WizDatasource<AiResponse>()
    .setSortFields([{ property: 'aiUid', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  public responseColumns:any[] = [
        { headerName: '$.ia.response.uid.$', width: 120, sortable: true, field: 'aiUid', tooltipField: 'aiUid' },
        { headerName: '$.ia.response.crc.$', width: 60, sortable: true, field: 'crc' },
        { headerName: '$.ia.response.content.$', minWidth: 100, flex: 1, sortable: false, field: 'response' }
      ];


  /**
   * Synchronisation des donnees
   */
  public wizSynchronizeData(): void {

    this.feedDS(); // alimentation des DS
  }


  /**
   * Alimentation du grid des free data
   */
  private feedDS() {
    // alimente la data source avec les données du model
    this.freedataDS.setSource(Model.getInstance().freedataEngine.getFreeDataList());
    this.freedataDS.setSelectedItems([Model.getInstance().currentEditedFreedata]);

    this.freedataDS.refresh();

    this.responseDS.setSource(Model.getInstance().aiResponseCollection);
    this.responseDS.refresh();
   }


  
  public doAct(action: string): void {
    let basestr;
    switch (action) {
      case 'question':
        this.questionResponse = null;
        basestr = this.aiQuestion.wizValue;
        new AiCmd(this.model).question('QUEST', basestr,this.backFromQuestion.bind(this), 150).execute();
        break;
      case 'image':
        this.imageResponse = null;
        basestr = this.aiImage.wizValue;
        new AiCmd(this.model).drawImage(basestr,this.backFromImage.bind(this)).execute();
        break;
    }
  }

  /**
  * retour sur IAquestion
  * @param result 
  */
  private backFromQuestion(result: any): void {
	if (result.response)
	{
		this.questionResponse = result.response;
	}
    this.cdref.markForCheck();
  }

   /**
  * retour sur IAimage
  * @param result 
  */
  private backFromImage(result: any): void {
    this.imageResponse = result.toString();
    this.cdref.markForCheck();
  }
 


  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {


      let ext: string = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2).toUpperCase();
      let kind: string = null;

      if (DOCUMENT_EXT.KIND_PDF.indexOf(ext) > -1) { // c'est un pdf
        kind = DOCUMENT_EXT.KIND_PDF;
      } else if (DOCUMENT_EXT.KIND_DOCX.indexOf(ext) > -1) { // c'est un docx
        kind = DOCUMENT_EXT.KIND_DOCX;
      }

      if(kind !== null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        const resAr: string[] = (event.target.result as string).split(',');

        let bytes: string = resAr[1];
        // extraction des mots clés du CV
        new AiCmd(this.model).extractCV(bytes, kind, this.backFromCV.bind(this)).execute();
        // extraction des vecteurs
        new AiCmd(this.model).extractVector(bytes, kind, this.backFromVector.bind(this)).execute();
      };
      }
      
    }
  }

  /**
  * retour sur lecture CV
  * @param result 
  */
  private backFromCV(result: any): void {
    this.cvResponse = result.toString();
    this.cdref.markForCheck();
  }


  /**
  * retour sur création vecteur
  * @param result 
  */
  private backFromVector(result: AiResponse): void {
    this.cvVector = result.response.toString();
    this.cdref.markForCheck();
  }
}